module.exports = {
  logon: {
    signIn: "账号登录",
    passwordLogin: "密码登录",
    login:"立即登录",
    iptAccount:"用户名/手机号/邮箱",
    selectCustomer:"请选择客户",
    iptPassword:"请输入密码",
    iptPasswordLen: "密码长度最少为6位",
    iptCheckcode:"请输入验证码",
    iptTrueCheckcode:"请输入正确的验证码",
    iptCheckcodeLen: "验证码长度位4位",
    forgetPassword: "忘记密码",
    register:"注册",
    home:"首页",
    customService:"客户服务",
    about:"关于我们",
    agree: "我已阅读并同意",
    privacyPolicy: "隐私政策",
    agreeMsg: "请同意隐私政策",
    selectEnterprise: "登录企业选择",
    copyRight: "中智薪税技术服务有限公司  京公网安备 11010502042147号 京ICP备07500522号-5",
    passwordTipTitle: "修改密码提示",
    passwordTipContent: "您好，您已长时间未更换密码，为了您的账号安全， 建议您更换密码！",
    updatePwdTipContent: "您好，为了您的账号安全，建议您更换初始密码！"
  },
  navbar: {
    userPhoto: "用户头像",
    switchLang: "中英切换"
  },
  areYouSureToSubmit: '是否确认提交?',
  confirmOperation: '确认操作？',
  tips: '提示',
  determine: '确定',
  cancel: '取消',
  save: '保存',
  nextStep: '下一步',
  prevStep: '上一步',
  done: '完成',
  close: '关闭',
  back: '返回',
  reflash: '刷新',
  Hi: '你好',
  more: '查看更多',
  salaryOverview: '薪资概况',
  total: '合计',
  average: '人均',
  gross: '应发',
  net: '实发',
  cost: '成本',
  personnelOverview: '人事概况',
  onJob: '在职人数',
  joined: '入职人数',
  resignation: '离职人数',
  /** 审批流程 - 付款通知审批设置 */
  payApvlSet: {
    processName: '流程名称',
    approvalLevel: '审批层级',
    default: '是否默认',
    status: '状态',
    createTime: '创建时间',
    operation: '操作',
    edit: '编辑',
    disable: '禁用',
    inputFilter: '关键字筛选',
    select: '请选择',
    inputPlaceholder: '请输入',
    newAdd: '新增',
    roleName: '角色名称',
    roleType: '角色类型',
    roleWarnTips: '请选择审批角色',
    roleSuccessTips: '保存成功',
    emptyTips: '此项不能为空',
    determine: '确 定',
    save: '保 存',
    cancel: '取 消',
    newProcessTitle: '新增流程',
    editProcessTitle: '编辑流程',
    disTitle: '提醒',
    successTips: '成功',
    cancelTips: '已取消',
    disText: '确定将所选流程禁用吗?',
    enaText: '确定将所选流程启用吗?',
  },
  /** 审批流程 - 付款通知审批 */
  payAdv: {
    salaryMonth: '工资月份',
    salaryPlaceholder: '请选择',
    currentMonth: '当前月',
    nearThreeMonth: '近三个月',
    nearOneYear: '近一年',
    other: '其它',
    startMonth: '开始月份',
    endMonth: '结束月份',
    to: '至',
    viewDetails: '查看详情',
    approvalProcess: '审批流程',
    totalAmountPayable: '应付总金额',
    useOfFinancialBalance: '使用财务余额',
    totalAmountPaid: '实付总金额',
    useOfCorporateBalance: '使用对公余额',
    noData: '暂无数据',
    proTips1: '您已提交审批意见, 现在流程到',
    proTips2: '已完成审核',
    proTips3: '您已驳回审批意见',
    proTips4: '未完成',
    proTips5: '您创建的薪资批次, 现在流转到',
    proTips6: '您创建的薪资批次被驳回, 是',
    confirmation: '确认意见',
    confirm: '确认',
    backToCIIC: '返回中智',
    approvalComments: '审批意见',
    agree: '同意',
    reject: '驳回',
    remarksTips: '请填写备注',
    errTips1: '请勾选审批意见',
    errTips2: '请填写驳回备注',
    errTips3: '备注不能超过200个字符',
    successTips: '审批完成',
    submit: '提交',
  },
  frame: {
    message: '消息中心',
    unreadMessage: '未读消息',
    enterTheMessageCenter: '进入消息中心',
    basicInformationSettings: '基本信息设置',
    logoutTipTitle: '提示',
    logoutTipContent: '确定退出系统吗？',
  },
  menu: {
    search: '搜索',
    QXInvestment: '乾象投资',
    workbench: '工作台',
    // 组织安排
    organization: '组织安排',
    organizationManagement: '组织管理',
    postManagement: '岗位管理',
    // 人事管理
    personnelManagement: '人事管理',
    onboardingManagement: '入职管理',
    staffManagement: '员工管理',
    contractManagement: '合同管理',
    // 考勤假期
    attendance: '考勤假期',
    clockInRecords: '打卡记录',
    attendanceResultProcessing: '考勤结果处理',
    attendanceMonthlyReport: '考勤月报',
    attendanceSummary: '考勤汇总',
    leaveQuery: '休假查询',
    attendanceDailyReport: '考勤日报',
    attendanceSettings: '考勤设置',
    leaveSettings: '休假设置',
    // 薪酬服务
    payroll: '薪酬服务',
    dataPreparation: '数据准备',
    salaryHistory: '薪酬历史',
    salaryDistribution: '薪酬发放',
    IITDeclaration: '个税申报',
    paySlipOnly: '仅工资条',
    salarySetting: '薪酬设置',
    refund: '退票',
    salaryCalculation: '薪资正算',
    salaryBackCalculation: '薪资倒算',
    // 审批流程
    approvalProcess: '审批流程',
    salaryApproval: '薪酬审批',
    approvalSettings: '审批设置',
    billApprovalSettings: '付款通知单审批设置',
    // 服务流程
    process: '服务流程',
    orderCenter: '订单中心',
    billList: '账单列表',
    invoiceList: '发票列表',
    // 数据统计
    statistics: '数据统计',
    staffIncomeDetails: '员工收入明细表',
    staffIncomeDetailsForGroup: '集团员工收入明细表',
    staffIncomeDetailsPerTaxType: '收入明细分计税类型表',
    staffIncomeSummary: '员工收入汇总表',
    dataCenter: '数据中心',
    costCenterSummary: '成本中心汇总表',
    salaryComparison: '工资对比表',
    costCenterComparison: '成本中心对比表',
    customReport: '自定义报表',
    // 四上报表
    sishangReport: '四上报表',
    enterpriseInformation: '企业信息',
    sishangEnterpriseReport: '四上企业报表',
    // 中智服务
    service: '中智服务',
    billLists: '账单',
    meritDataManagement: '绩效数据管理',
    meritDetail: '绩效明细',
    // 政策字典
    policy: '政策字典',
    socialSecurityPolicy: '社保政策',
    housingProvidentFundPolicy: '公积金政策',
    // 平台设置
    settings: '平台设置',
    companyInformation: '公司信息',
    accountSettings: '账户设置',
    HRPermissionSettings: 'HR权限设置',
    userAuthorization: '用户授权',
    systemSettings: '系统设置',
    codeSettings: '代码设置',
    messageSettings: '消息设置',
    // customerAnnouncement: '客户公告',
    staffPermissionManagement: '员工权限管理',
    // 审计报表
    auditReport: '审计报表',
    payTaxCloudLogDetails: '薪税云日志详情',
    payTaxCloudDailyVisitStatistics: '薪税云日访问统计',
    payCloudLogDetails: '薪酬云日志详情',
    // 特斯拉股票行权
    stockExerciseEmail: '股票行权邮件管理',
    debtManagement: '欠款管理',
    mailSettings: '邮件设置',
    // 政策库
    policyLibrary: '政策库',
    policyDictionary: '政策字典',
    policyExpress: '政策速递',
    industryReport: '行业报告',
    serviceTemplate: '业务模板',
    documentTemplate: '文档模板',
    guidance: '办事指南',
    // 政策库后台管理
    policyLibraryManagement: '政策库管理',
    policyLink: '政策链接管理',
    policyLibraryPermission: '政策库权限管理',
    policyExpressMailSubscription: '政策速递邮件订阅管理',
    industryReportManagement: '行业报告管理',
    //工资单
    payslip:'工资单',
    unpaybatchinfo:'待发放批次',
    payslipdetail:'已发放工资单',
    ProofMenu:'证明开具',
    incomeProofMenu:'薪资证明开具',
    //特斯拉记录数据
    teslaCustom:'特斯拉定制',
    teslaCustomData:'特斯拉记录数据',
    teslaPayAccount:'工资记账报表',
    // 数据录入
    dataInput: '数据录入',
    overallBudget: '总体预算',
    employeeCompensation: '员工薪酬水平',
    //希捷文件配置
    seagateFile:'希捷文件',
    seagateFileDownload:'希捷文件下载',
    seagateFinanceReport:'希捷财务报表'
  },
  // 工作台
  workbench: {
    shortcuts: '快捷功能',
    policyExpress: '政策速递'
  },
  // 数据中心
  reportName: '报表名称',
  numberOfEmployees: '在职人数',
  joinedLastMonth: '上月入职人数',
  resignationLastMonth: '上月离职人数',
  averageAge: '平均年龄',
  averageService: '平均司龄',
  YoYLastMonth: '同比上月',
  dataBoard: '数据看板',
  customReport: '自定义报表',
  averageGrossSalaryForThisMonth: '平均应发薪资',
  averageNetSalaryForThisMonth: '平均实发薪资',
  averageLaborCostForThisMonth: '平均人力成本',
  perCapitaLaborCost: '人均人力成本',
  netSalary: '实发薪资',
  socialSecurityAndProvidentFund: '社保公积金',
  IIT: '个人所得税',
  others: '其他',
  unCounted: '未统计',
  quantile: '位',
  illustration: '说明',
  nativePlaceDistribution: {
    title: '员工籍贯分布统计',
    illustration: '当前系统内在职员工的籍贯热力图。'
  },
  statisticsOfChanges:{
    title: '员工人数变动统计',
    illustration: '所选时间周期内系统内在职、入职、离职按月人数统计。'
  },
  monthlyEmployeeSalaryStatistics: {
    title: '员工薪资月度统计',
    illustration: '所选时间周期内系统内发薪的员工的应发、实发、人力成本合计值或人均值按月统计。'
  },
  salaryCompositionRatioStatistics: {
    title: '薪资构成比例统计',
    illustration: '所选时间周期内系统内发薪的员工的平均人力成本，及平均实发工资、平均社保公积金、平均个税、其他，占平均人力成本比例图。'
  },
  employeeSalaryDistributionStatistics: {
    title: '员工薪资分布统计',
    illustration: '所选时间周期内系统内发薪的员工的应发、实发、人力成本分位图。'
  },
  departmentSalaryRatioStatistics: {
    title: '部门薪资比例统计',
    illustration: '所选时间周期内系统内各部门发薪的员工的应发、实发、人力成本合计值比例图。'
  },
  salaryTypeProportionStatistics: {
    title: '薪资类型比例统计',
    illustration: '所选时间周期内系统内发薪的类型比例图。'
  },
  employeeAgeRatioStatistics: {
    title: '员工年龄比例统计',
    illustration: '当前系统内在职员工的年龄分布图。',
    seriesName: '员工年龄比例'
  },
  employeeServiceRatioStatistics: {
    title: '员工司龄比例统计',
    illustration: '当前系统内在职员工的司龄比例图。',
    seriesName: '员工司龄比例'
  },
  costCenterProportionStatistics: {
    title: '成本中心比例统计',
    illustration: '所选时间周期内系统内各成本中心发薪的员工的应发、实发、人力成本合计值比例图。'
  },
  educationDistributionStatistics: {
    title: '学历分布统计',
    illustration: '当前系统内在职员工的学历比例图。',
    seriesName: '学历分布统计'
  },
  genderStatistics: {
    title: '性别统计',
    illustration: '当前系统内在职员工的性别比例图。',
    seriesName: '性别统计'
  },
  // 订单
  createOrder: '创建订单',
  deleteOrder: '删除订单',
  confirmDeleteTip: '确定删除订单',
  deleteSuccessfully: '删除成功',
  wageMonth: '工资月份',
  payDate: '发薪日期',
  remarks: '备注',
  informationAttachments: '信息附件',
  validateWageMonth: '发薪日期不能早于工资月份',
  // 账单列表
  downloadBills: '下载账单',
  // 发票列表
  downloadInvoice: '下载发票',
  // 政策库
  scopeOfApplication: '适用范围',
  hotSearch: '热门搜索',
  permissionTip: '对不起，您暂无此地区数据查询权限',
  permissionContact: '请您联系对接业务员！',
  payPolicy: '薪酬政策',
  socialSecurityProvidentFundPolicy: '社保公积金政策',
  year: '年度',
  minimumWage: '最低薪资',
  monthlySalary: '月社平工资',
  taxExemptAmountForSeverancePay: '离职金免税金额',
  effectiveDate: '生效日期',
  expiryDate: '失效日期',
  salaryType: '薪资类型',
  amount: '金额',
  socialSecurity: '社保',
  providentFund: '公积金',
  upperLimitOfPensionTaxExemption: '养老金免税上限',
  upperLimitOfMedicalTaxExemption: '医疗免税上限',
  upperLimitOfUnemploymentTaxExemption: '失业免税上限',
  upperLimitOfTaxExemption: '免税上限',
  notes: '注意事项',
  mattersTip: '以上数据为社保公积金免税上限，非缴纳上限！',
  upperLimitOfTaxExemptionTip: '以上数据仅供参考，如对数据有疑问，请联系您的客服。',
  relatedPolicyLinks: '相关政策链接：',
  HRPolicyExpress: '人力资源政策速递',
  HRKnowledgePark: '人力资源知识园地',
  searchHistory: '搜索历史',
  downloadReport: '报告下载',
  documentName: '文档名称',
  template: '模板',
  businessScenario: '业务场景',
  // 政策库管理
  policyType: '政策类型',
  policyName: '政策名称',
  policyLink: '政策链接',
  createLink: '创建链接',
  editLink: '编辑链接',
  deleteLink: '删除链接',
  sureDeleteLink: '确认删除链接',
  correctLinkTip: '请输入正确的链接',

  customerName: '客户名称',
  customerNumber: '客户编号',
  policyLibraryPermissions: '政策库权限',

  accountName: '账户名称',
  userName: '姓名',
  phoneNumber: '手机号码',
  email: '邮箱',
  subscriptionStatus: '订阅状态',


  reportsName: '报告名称',
  uploadReport: '上传报告',
  applicableIndustry: '适用行业',
  reportCover: '报告封面',
  reportFile: '报告文件',
  handleCreateReport: '创建报告',
  handleEditReport: '编辑报告',
  handleDeleteReport: '删除报告',
  sureDeleteReport: '确认删除报告',

  // 表格、表单、按钮等
  clear: '清空',
  inputKeyword: '请输入关键词',
  keywords: '关键词',
  pleaseSelect: '请选择',
  pleaseQuery: '请查询',
  query:'查询',
  confirm:'确认',
  pleaseUpload: '请上传',
  inputPlaceholder: '请输入',
  selectYearMonth: '请选择年月',
  selectDate: '请选择日期',
  rangeSeparator: '至',
  from: '开始',
  to: '结束',
  startDate: '开始日期',
  endDate: '结束日期',
  selectStaff: '请选择员工',
  selectCards: '请输入证件号',
  selectCostCenter: '请选择成本中心',
  selectTaxType: '请选择计税类型',
  displayItemConfiguration: '显示项目配置',
  displayItems: '显示项目',
  hiddenItems: '隐藏项目',
  salaryMonth: '工资所属月份',
  export: '导出',
  displayItem: '要显示信息项（拖拽信息项目进行排序）',
  allItem: '全部信息项（拖拽或点击信息项目到上面区域）',
  seq: '序号',
  selectAll: '全选',
  noData: '暂无数据',
  noReport: '暂无自定义报表，快去创建吧～',
  editReport: '编辑报表',
  viewStatistics: '查看统计',
  createCustomReport: '创建自定义报表',
  editCustomReport: '编辑自定义报表',
  enterReportName: '请输入报表名称',
  reportType: '报表类型',
  searchStatisticalCaliber: '请搜索统计口径',
  selectStatisticalCaliber: '请选择统计口径',
  caliberSelected: '',
  algorithm: '入离职月算法',
  salaryRange: '工资区间',
  comparisonRange: '对比区间',
  startYearMonth: '开始年月',
  endYearMonth: '结束年月',
  viewDetails: '查看明细',
  handleCreate: '创建',
  handleEdit: '编辑',
  handleDelete: '删除',
  startDownloading: '开始下载',
  sum: '合计',
  operation: '操作',
  uploadFiles: '上传文件',
  uploadFilesTip: '将文件拖到此处或点击上传。',
  turnOff: '后自动关闭',
  seconds: '秒',
  // 日历
  datePicker: {
    workday: '工作日',
    dayOff: '休息日',
    statutoryHoliday: '法定节假日'
  },
  selectSummaryStaff: '请选择汇总项',
  download: '下载',
  zipdownload: '批量下载工资条',
  zipdownloadTask: '批量下载工资条进度查询',
  batchNo: '批次编号',
  createTime: '创建时间',
  salesman: '服务人员',
  payAmountTotal: '应发金额合计',
  actAmountTotal: '实发工资合计',
  successTips: '保存成功',
  noEmptyColumn: '显示项目不能为空',
  pleaseSelectPaidResultRow: '请先选择要下载的发薪结果。',
  status: '状态',
  enabledownload: '可下载',
  preparing: '正在生成。。。',
  previewWechatPayslip : '预览微信工资单',
  previewEMailPayslip : '预览邮件工资单',
  sumRemark:"要显示信息项（拖拽信息项目进行排序） （仅可汇总数字项）",
  incomeProof: '薪资证明下载',
  incomeProof1: '薪资证明',
  createProofAndDownload:"合并生成证明并下载",
  createEachAndDownload:"各雇员分别生成证明并下载",
  downloadWordType:"下载word版本",
  downloadPdfType:"下载pdf版本",
  cusHeadRemark:"为了薪资证明文件美观性，建议显示项目不超过10项",
  dealStatus:"处理状态",
  perStatusType:"人员数据类型",
  companyCode:"公司",
  batchIds:"请输入批次(多个批次逗号间隔)",
  queryDate:"查询日期",
  queryCompany:"请选择查询公司",
  sendEmail:"发送邮件"
}
